import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  // eslint-disable-next-line @typescript-eslint/naming-convention
  private readonly DAY_MILLISECONDS: number = 24 * 60 * 60 * 1000;

  constructor() {}

  public get(name: string): string | undefined {
    const decodedCookie: string = decodeURIComponent(document.cookie);
    const cookies: string[] = decodedCookie.split(';');
    for (const cookie of cookies) {
      const cookieArray: string[] = cookie.trim().split('=');
      if (name === cookieArray[0]) {
        return cookieArray[1];
      }
    }
    return undefined;
  }

  public set(name: string, value: string, expDays?: number) {
    let expires = '';
    if (expDays) {
      const date: Date = new Date();
      date.setTime(date.getTime() + (expDays * this.DAY_MILLISECONDS));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
  }

  public delete(name: string): void {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
}
